import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';
import styled from 'styled-components';

import { Button } from '../components/button/button';
import { InfoBox } from '../components/info-box/info-box';
import { PageContainer } from '../components/page-container';
import { useReloadPage } from '../hooks/use-reload-page';

/**
 * Root-level error element for React Router. Rendered whenever a descendant
 * route throws during render, replacing React Router's default
 * "Unexpected Application Error!" screen.
 */
export const RouteErrorBoundary = () => {
  const { t } = useTranslation();
  const error = useRouteError();
  const { reload, isReloading } = useReloadPage();

  React.useEffect(() => {
    // Keep the original error visible in the console for debugging.
    console.error('Application crashed:', error);
  }, [error]);

  return (
    <PageContainer title={t('applicationCrashedTitle', { ns: 'common' })}>
      <Content>
        <InfoBox color="red" leftIcon={{ icon: ['fad', 'exclamation'] }}>
          {t('applicationCrashed', { ns: 'common' })}
        </InfoBox>
        <Button color="primary" loading={isReloading} variant="contained" onClick={reload}>
          {t('reloadPage', { ns: 'common' })}
        </Button>
      </Content>
    </PageContainer>
  );
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1em;
`;
